/**
 * Scripts used for fraud prevention in forms
 *
 * @module views/components/FraudCheckScript
 * @memberof -Common
 */
import React from 'react';

import JSscriptTag from '../JSscriptTag/JSscriptTag';

export const IOVATION_CORE = 'JS_IOVATIONCORE';
export const IOVATION_CONFIGURATION = 'JS_IOVATIONCONFIGURATION';
export const IOVATION_HIDDEN_FIELD_ID = 'iovationBlackBox';
export const iovationCoreUrls = {
  production: 'https://mpsnare.iesnare.com/snare.js',
  developement: 'https://ci-mpsnare.iovation.com/snare.js'
};

/**
 * Represents a FraudCheckScript component
 *
 * @method
 * @returns FraudCheckScript
 */
export const FraudCheckScript = () => {
  const iovationCoreUrl = process.env.NODE_ENV === 'production' ? iovationCoreUrls.production : iovationCoreUrls.developement;
  if( !iovationCoreUrl ){
    return null;
  }
  return (
    <>
      <JSscriptTag
        type='text/javascript'
        tagId={ IOVATION_CORE }
        src={ iovationCoreUrl }
        forceReload={ true }
      />
      <JSscriptTag
        type='text/javascript'
        tagId={ IOVATION_CONFIGURATION }
        body={ `
        //Iovation Support for FRAUD control

        // basic configuration
        var io_bbout_element_id = "${IOVATION_HIDDEN_FIELD_ID}"; // populate iovationBlackBox in form
        var io_install_stm = false; // do not install ActiveX
        var io_install_flash = false; // do not install ActiveX
        var io_exclude_stm = 12; // exclude Active X on XP and higher

        // configure parameters for network latency
        var io_submit_element_id = "finalSubmit"; // tie to form's submit button
        var io_max_wait = 3000; // wait 3 seconds
        var io_submit_form_id = "CreditCardApplicationForm";
      ` }
      />
    </>
  );
};

export default FraudCheckScript;

export const FraudCheckHiddenField = () => (
  <input
    id={ IOVATION_HIDDEN_FIELD_ID }
    name={ IOVATION_HIDDEN_FIELD_ID }
    type='hidden'
  />
);
